import React from 'react';
import './Problem.css';

const Problem = () => {
  const questions = [
    "We bought the licenses. Now what?",
    "Which of our tools could we just build ourselves?",
    "Who's going to actually ship this?",
    "Do we hire a platform team to chase a moving target?"
  ];

  return (
    <section className="section problem">
      <div className="container">
        <div className="problem-content">
          <h2 className="problem-main-title">
            Owning AI and using it are two different things.
          </h2>
          
          <h3 className="problem-subtitle">
            The gap between them has never actually been closed, until someone comes and sits inside the business to close it.
          </h3>
          
          <div className="problem-questions-list">
            {questions.map((question, index) => (
              <div key={index} className="problem-question-item">
                <span className="problem-quote-mark">"</span>
                <p className="problem-question-text">{question}</p>
                <span className="problem-quote-mark">"</span>
              </div>
            ))}
          </div>
          
          <p className="problem-closing">
            The budget is real. The momentum is real. The thing that turns it into working software has been missing.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Problem;

